// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.premiumBenefits_benefitsSection__sNSXl {
  background: #1a1a1a;
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));
  border-radius: 16px;
  padding: 24px 16px;
  margin: 0 16px 20px;
  font-family: "Noto Sans", sans-serif;
  position: relative;
  overflow: hidden;
  /* padding-bottom: 50px; */
}

.premiumBenefits_benefitsSection__sNSXl > *:not(.premiumBenefits_backgroundGlow__nQy0u) {
  position: relative;
  z-index: 1;
}

.premiumBenefits_backgroundGlow__nQy0u {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
  mask-image: linear-gradient(to bottom, black 80%, transparent);
}

.premiumBenefits_backgroundSvg__GiVPv {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  min-width: 360px;
  min-height: 684px;
}

.premiumBenefits_benefitsTitle__K2yUp {
  font-size: 18px;
  font-weight: 600;
  color: #fdd1e6;
  text-align: center;
  margin-bottom: 15px;
  line-height: 22px;
  font-family: "Noto Sans", sans-serif;
}

.premiumBenefits_benefitsGrid__OFF8s {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.premiumBenefits_benefitItem__0vERY {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.premiumBenefits_benefitIcon__pjZl1 {
  width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.premiumBenefits_benefitText__tbukP {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-top: -10px;
}

.premiumBenefits_benefitTitle__4vswT {
  font-size: 12px;
  font-weight: 500;
  color: #C1C3CF;
  text-align: center;
  line-height: 15px;
  font-family: "Noto Sans", sans-serif;
}

.premiumBenefits_benefitSubtitle__SA4Hg {
  font-size: 12px;
  font-weight: 500;
  color:  #C1C3CF;
  text-align: center;
  line-height: 12px;
  font-family: "Noto Sans", sans-serif;
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/PremiumBenefits/premiumBenefits.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,8FAA8F;EAC9F,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;AACtC","sourcesContent":[".benefitsSection {\n  background: #1a1a1a;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n  border-radius: 16px;\n  padding: 24px 16px;\n  margin: 0 16px 20px;\n  font-family: \"Noto Sans\", sans-serif;\n  position: relative;\n  overflow: hidden;\n  /* padding-bottom: 50px; */\n}\n\n.benefitsSection > *:not(.backgroundGlow) {\n  position: relative;\n  z-index: 1;\n}\n\n.backgroundGlow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n  mask-image: linear-gradient(to bottom, black 80%, transparent);\n}\n\n.backgroundSvg {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  height: 100%;\n  min-width: 360px;\n  min-height: 684px;\n}\n\n.benefitsTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #fdd1e6;\n  text-align: center;\n  margin-bottom: 15px;\n  line-height: 22px;\n  font-family: \"Noto Sans\", sans-serif;\n}\n\n.benefitsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.benefitItem {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.benefitIcon {\n  width: 65px;\n  height: 65px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.benefitText {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  margin-top: -10px;\n}\n\n.benefitTitle {\n  font-size: 12px;\n  font-weight: 500;\n  color: #C1C3CF;\n  text-align: center;\n  line-height: 15px;\n  font-family: \"Noto Sans\", sans-serif;\n}\n\n.benefitSubtitle {\n  font-size: 12px;\n  font-weight: 500;\n  color:  #C1C3CF;\n  text-align: center;\n  line-height: 12px;\n  font-family: \"Noto Sans\", sans-serif;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"benefitsSection": `premiumBenefits_benefitsSection__sNSXl`,
	"backgroundGlow": `premiumBenefits_backgroundGlow__nQy0u`,
	"backgroundSvg": `premiumBenefits_backgroundSvg__GiVPv`,
	"benefitsTitle": `premiumBenefits_benefitsTitle__K2yUp`,
	"benefitsGrid": `premiumBenefits_benefitsGrid__OFF8s`,
	"benefitItem": `premiumBenefits_benefitItem__0vERY`,
	"benefitIcon": `premiumBenefits_benefitIcon__pjZl1`,
	"benefitText": `premiumBenefits_benefitText__tbukP`,
	"benefitTitle": `premiumBenefits_benefitTitle__4vswT`,
	"benefitSubtitle": `premiumBenefits_benefitSubtitle__SA4Hg`
};
export default ___CSS_LOADER_EXPORT___;
